function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.26 2.749a2.004 2.004 0 011.41 1.41c.343 1.252.33 3.862.33 3.862s0 2.596-.33 3.848a2.005 2.005 0 01-1.41 1.41c-1.252.33-6.26.33-6.26.33s-4.995 0-6.26-.343a2.005 2.005 0 01-1.41-1.41C0 10.617 0 8.008 0 8.008S0 5.41.33 4.159a2.046 2.046 0 011.41-1.423c1.252-.33 6.26-.33 6.26-.33s5.008 0 6.26.343zm-3.69 5.259l-4.165 2.398V5.61l4.165 2.399z",
  fill: "#E1E8F2"
});

var SvgYoutubeWhite = function SvgYoutubeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgYoutubeWhite;